"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppStateConstants_1 = require("../../types/AppStateConstants");
const callableTakePhoto = ({ functionId, callbacks, executeProcesses, store, }) => {
    const onTake = (uri) => {
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.FULL_SCREEN_CAMERA_REQUEST_CLOSE,
        });
        if (uri) {
            executeProcesses(functionId, callbacks.onTake, uri);
        }
    };
    const onClose = () => {
        executeProcesses(functionId, callbacks.onCancel);
    };
    const onRejectedPermissions = () => {
        executeProcesses(functionId, callbacks.onRejectedPermissions);
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.FULL_SCREEN_CAMERA_REQUEST_CLOSE,
        });
    };
    store.dispatch({
        type: AppStateConstants_1.AppStateConstants.FULL_SCREEN_CAMERA_REQUEST_OPEN,
        payload: {
            onBarCodeRead: undefined,
            onQRCodeRead: undefined,
            onStopRecord: undefined,
            onTakePicture: onTake,
            onClose,
            onRejectedPermissions,
        },
    });
};
exports.default = callableTakePhoto;
